import { Button, ButtonGroup, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { getPatient } from "../services/get.service";
import { toast } from "react-toastify";
import { patient, user } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";

const SearchPatient = (props: {setPatient: (patient: patient) => void; user: user | null}) => {
    const [cardorPhone, setCardorPhone] = useState("")
    const { setPatient: setPatientToStore, user } = props
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [patient, setPatient] = useState<patient>()
    const OnSubmit = (e: SyntheticEvent) => {
        e.preventDefault()
        setLoading(true)
        setPatient(undefined)

        getPatient(cardorPhone)
            .then((res) => {
                setPatient(res.data)
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false)
                console.log(err);
                toast.error("Not Found!", {
                    theme: "colored",
                    autoClose: 2500,
                    type: "error",
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                })
            })
    }

    return <>
        <Helmet>
            <title>Search Patient</title>
        </Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full lg:px-20 px-3 py-48 pt-5">
                    <ButtonGroup className="gap-2">
                        {user?.roles.some((r) => r.name === "Admin" || r.name === "Doctor" || r.name === "Cashier") &&
                        <Button variant="contained">
                            <Link to="/create/patient">Add New</Link>
                        </Button>}
                        <Button variant="contained">
                            <Link to="/patients">All Patient</Link>
                        </Button>
                    </ButtonGroup>
                    <Typography variant="h4" fontSize={32} className="py-3">Search Patient</Typography>
                    <form className="flex flex-row" onSubmit={OnSubmit}>
                        <TextField onChange={(e) => setCardorPhone(e.target.value)} fullWidth size="small" required placeholder="Card No or Phone No" />
                        <Button type="submit" variant="contained">Search</Button>
                    </form>
                    <div className="py-3">
                        {
                            patient !== undefined ?
                                loading
                                    ? <ClipLoader loading={loading} size={20} />
                                    : <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>First Name</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Middle Name</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Last Name</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Card Number</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Phone Number</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Branch Name</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow hover={true} onClick={() => { setPatientToStore(patient); navigate('/patient') }}>
                                                    <TableCell>{patient?.firstName}</TableCell>
                                                    <TableCell>{patient?.middleName}</TableCell>
                                                    <TableCell>{patient?.lastName}</TableCell>
                                                    <TableCell>{patient?.cardNo}</TableCell>
                                                    <TableCell>{patient?.phoneNumber}</TableCell>
                                                    <TableCell>{patient?.branchName}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                :
                                <></>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default SearchPatient;
